import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import {
  ColumnaTodosJuicios,
  CuerpoTodosJuicios,
  TipoJuicioOpcion,
} from '@flows/requirement/juicios-todos/juicios-todos.logic';

export interface ConfigGrillaModulo {
  headers: ColumnaTodosJuicios[];
  filters: {
    cliente: string[];
    competencia: string[];
    etapaPjud?: string[];
    estadoPjud?: string[];
    estadoNegocio?: string[];
    tipoJuicio?: TipoJuicioOpcion[];
  };
}

export interface PaginaGrillaModulo {
  recordsTotal: number;
  data: Array<Record<string, unknown>>;
}

/** Grilla con los requerimientos de todos los flujos de un módulo de la Suite. */
@Injectable({ providedIn: 'root' })
export class RequirementByModuleService {
  private readonly base = `${environment.apiUrl}/trackvision/requirement/list`;

  constructor(private http: HttpClient) {}

  getConfig(suitemodule: 'juicios'): Observable<ConfigGrillaModulo> {
    return this.http
      .post<{ result: ConfigGrillaModulo }>(`${this.base}/bymoduleconfig`, { suitemodule })
      .pipe(map((r) => r.result));
  }

  getPage(cuerpo: CuerpoTodosJuicios): Observable<PaginaGrillaModulo> {
    return this.http
      .post<{ result: PaginaGrillaModulo }>(`${this.base}/bymodule`, cuerpo)
      .pipe(map((r) => r.result));
  }
}
